import { AutogenLayoutCarriersForAssignment } from "./autogen/AutogenLayoutCarriersForAssignment";

export class CarriersForAssignment extends AutogenLayoutCarriersForAssignment {
}
